export const deleteWhitespaces = (text: string) =>
  text.replace(/\s+/g, '').replace(/&nbsp;/g, '');
